'use client';

import React from 'react';
import { Props as FooterProps } from 'components/commercetools-ui/organisms/footer';
import { FooterLink } from 'components/commercetools-ui/organisms/footer/atoms/column';
import { TasticProps } from '../types';

interface Props extends FooterProps {
  headerCol1: string;
  linksCol1: FooterLink[];
  headerCol2: string;
  linksCol2: FooterLink[];
  headerCol3: string;
  linksCol3: FooterLink[];
  headerCol4: string;
  linksCol4: FooterLink[];
}

const FooterTastic = ({ data }: TasticProps<Props>) => {

  return (
    <div className="fixed-screen-width lg:relative-width">
    </div>
  );
};

export default FooterTastic;
